var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listItems)?_c('ul',{class:[_vm.wrapperClass, _vm.openClose]},_vm._l((_vm.listItems),function(item,index){return _c('li',{key:index,class:_vm.spanItemClass,on:{"click":function($event){return _vm.$emit('clickAction', item)}}},[_c('span',[_vm._v(_vm._s(item))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }